import React from 'react';
import {useLastFilterPreview} from '../../../data/hooks/preview';
import {useString} from '../../../data/hooks/strings';

function Preview(props) {
    const {onShowPreview} = props,
        filteredObjectsName = useString('filteredObjectsName'),
        previewLinkText = useString('previewLinkText'),
        afterConditionsPreview = useLastFilterPreview();

    return (
        <div className="row">
            <div className="col-md-10"></div>
            <div className="col-md-2 text-center">
                <div className="recipients">{filteredObjectsName}</div>
                <br />
                {onShowPreview && afterConditionsPreview ? (
                    <a href="#" onClick={onShowPreview}>
                        {previewLinkText ?? 'Show preview'}
                    </a>
                ) : null}
            </div>
        </div>
    );
}

export default Preview;
